export enum ModuleNames {

  // when using modules, user references this
  CoreModule = "@dyna-grid/core", // should this be @dyna-grid/core?
  // when not using modules, user references this
  AllModules = "@dyna-grid/all", // should this be dyna-grid-all

  // community modules
  InfiniteRow = "@dyna-grid/infinite-data",
  ClientSideRow = "@dyna-grid/client-data",
  CsvExportModule = "@dyna-grid/csv-export",

  // pro core - users never import on this, but other pro modules do
  ProCoreModule = "@pro-dyna-grid/core", // should this be pro-dyna-grid/core?
  // when not using modules, user references this
  ProAllModules = "@pro-dyna-grid/all", // should this be Pro All Modules

  // pro modules
  ExpandRows = "@pro-dyna-grid/expand-rows",
  ColumnToolPanel = "@pro-dyna-grid/column-tool-panel",
  FiltersToolPanel = "@pro-dyna-grid/filter-tool-panel",
  Menu = "@pro-dyna-grid/menu",
  SetFilter = "@pro-dyna-grid/set-filter",
  MultiFilter = "@pro-dyna-grid/multi-filter",
  StatusBar = "@pro-dyna-grid/status-bar",
  SideBar = "@pro-dyna-grid/side-bar",
  RangeSelection = "@pro-dyna-grid/range-selection",
  RowDetails = "@pro-dyna-grid/row-details",
  RichSelect = "@pro-dyna-grid/rich-select",
  GridCharts = "@pro-dyna-grid/charts",
  ViewportRow = "@pro-dyna-grid/viewport-row",
  ServerSideRow = "@pro-dyna-grid/server-data", // or
  ExcelExport = "@pro-dyna-grid/excel-export",
  Clipboard = "@pro-dyna-grid/clipboard",
  DateTimeEditor = "@pro-dyna-grid/date-time-editor",

  ReactModule = "@dyna-grid/react",
  VueModule = "@dyna-grid/vue",

}
